import {createEffectFn} from '@ngneat/effects';
import {debounceTime, Observable, switchMap, tap} from 'rxjs';
import {OrganisationConfigState} from '@store/settings/organisationsConfig/organisationsConfig.store';
import {organisationsConfigService} from '@store/settings/organisationsConfig/organisationsConfig.service';

type SearchOrganisationsConfigParams = Partial<OrganisationConfigState>

export const searchOrganisationsConfigEffect = createEffectFn((params$: Observable<SearchOrganisationsConfigParams>) => {
  return params$
    .pipe(
      tap(() => console.log('hello')),
      debounceTime(300),
      switchMap(() => organisationsConfigService.getOrganisationsConfig())
    );
});
